module.exports = __webpack_public_path__ + "static/assemblaggio_mocio_2-8da8a1cf11af05383d6e31f72e8f7fe1.jpg";